export default function (Vue) {
  Vue.toastr = {
    //success
    success: (message) => {
      return Vue.prototype.$toast.add({
        severity: "success",
        summary: "Success",
        detail: message,
        life: 10000,
      });
    },
    //info
    info: (message) => {
      return Vue.prototype.$toast.add({
        severity: "info",
        summary: "Read me",
        detail: message,
        life: 10000,
      });
    },
    //warn
    warn: (message) => {
      return Vue.prototype.$toast.add({
        severity: "warn",
        summary: "Warning",
        detail: message,
        life: 10000,
      });
    },
    //error
    error: (message) => {
      return Vue.prototype.$toast.add({
        severity: "error",
        summary: "Error",
        detail: message,
        life: 10000,
      });
    },
  };

  Object.defineProperties(Vue.prototype, {
    $toastr: {
      get: () => {
        return Vue.toastr;
      },
    },
  });
}
